// Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const labelSlice = createSlice({
  name: "label",
  initialState: [] as string[],
  reducers: {
    setLabels: (state, action: PayloadAction<string[]>) => action.payload,
  },
});

export const { setLabels } = labelSlice.actions;

export default labelSlice.reducer;
